// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/rubik-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/rubik-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/rubik-medium-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/rubik-medium-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/rubik-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/rubik-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/backgrounds/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: bold;
  font-style: normal;
}


* {
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
  font-family: "Rubik";
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  background: gold;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .logo {
    cursor: pointer;
  }

  :first-child {
    h1 {
      margin-bottom: 0;
    }

    h2 {
      margin-top: 0;
      font-weight: 500;
    }
  }

  button {
    border: none;
    background: none;
    font: inherit;
    font-size: 1.1rem;
    font-weight: 500;

    &+button {
      margin-left: 1rem;
    }

    &:hover {
      border-bottom: 3px solid black;
      margin-bottom: -3px;
      cursor: pointer;
    }
  }
}

#content {
  flex: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-color: rgba(0, 0, 0, .5);
  background-blend-mode: multiply;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  min-height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB;0DACiE;EACjE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DACgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;0DAC8D;EAC9D,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;;EAEnB;IACE,eAAe;EACjB;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,gBAAgB;IAClB;EACF;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;;IAEhB;MACE,iBAAiB;IACnB;;IAEA;MACE,8BAA8B;MAC9B,mBAAmB;MACnB,eAAe;IACjB;EACF;AACF;;AAEA;EACE,OAAO;EACP,yDAAmE;EACnE,mCAAmC;EACnC,+BAA+B;;EAE/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;;EAEtB,iBAAiB;AACnB","sourcesContent":["@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-regular-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-regular-webfont.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-medium-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-medium-webfont.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('./assets/fonts/rubik-bold-webfont.woff2') format('woff2'),\n    url('./assets/fonts/rubik-bold-webfont.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n}\n\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: \"Rubik\";\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nheader {\n  background: gold;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n  .logo {\n    cursor: pointer;\n  }\n\n  :first-child {\n    h1 {\n      margin-bottom: 0;\n    }\n\n    h2 {\n      margin-top: 0;\n      font-weight: 500;\n    }\n  }\n\n  button {\n    border: none;\n    background: none;\n    font: inherit;\n    font-size: 1.1rem;\n    font-weight: 500;\n\n    &+button {\n      margin-left: 1rem;\n    }\n\n    &:hover {\n      border-bottom: 3px solid black;\n      margin-bottom: -3px;\n      cursor: pointer;\n    }\n  }\n}\n\n#content {\n  flex: 1;\n  background-image: url('./assets/images/backgrounds/background.jpg');\n  background-color: rgba(0, 0, 0, .5);\n  background-blend-mode: multiply;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  min-height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
